exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3[data-v-80b13a60] {\n    text-align: center;\n}\n.privacy-link[data-v-80b13a60] {\n    margin: 20px 0 0 5px;\n    text-decoration: underline;\n}\n", ""]);

// exports
